module.exports = __webpack_public_path__ + "static/media/Sort A-z.d9bbbfc4.svg";